import React, { FC } from 'react';
import { SVGTooltipProps } from '@utils';
import { SvgWithTooltip } from "./SvgWithTooltip";

export const Information: FC<SVGTooltipProps> = ({ onClick, divClassName,tooltip }) => (
  <SvgWithTooltip
    onClick={onClick}
    divClassName={divClassName}
    tooltip={tooltip}
  >
    <svg 
      width="18" 
      height="18"
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fill="#3273E1"
        d="M16,1A15,15,0,1,0,31,16,15,15,0,0,0,16,1Zm2,22a2,2,0,0,1-4,0V16a2,2,0,0,1,4,0ZM16,12.19A2.19,2.19,0,1,1,18.19,10,2.19,2.19,0,0,1,16,12.19Z"
      />
    </svg>
  </SvgWithTooltip>
);
